import { AppHelper } from "../appHelper"
import { AppBaseProps, CommonApp, Entity } from "../core/components/commonApp";
import { NotificationHelper } from "../core/util/notificationHelper";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { Helper } from "../core/util/helper";
import React from "react";
export default class EditFlexTime extends React.Component<EditFlexTimeAppProps, any> {
    common = new AppHelper();
    translations: Array<String>;
    errorText: string;

    constructor(props) {
        super(props);
        this.common.init(this);
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    private _inLastMonth(date: string) {
        const c1 = Helper.dates.compareMultiTypeDates(this.props.entity.MonthStart, date, true); //-1 or 0
        const c2 = Helper.dates.compareMultiTypeDates(date, this.props.entity.MonthEnd, true); //-1 or 0
        return c1 <= 0 && c2 <= 0;
    }

    private _is10(min: number) {
        return min < 9 || min > 9;
    }

    private checkErrors() {
        let res = false;
        this.errorText = "";

        if (this._inLastMonth(this.props.entity.Datum)) {
            if (this._is10(this.props.entity.Minuten)) {
                res = true;
            } else {
                this.errorText = this.translations["WebSMS.FlexTime.ErrorMinMinutes"]; //"error Min must be > 10 or < -10";
            }
        } else {
            this.errorText = this.translations["WebSMS.FlexTime.ErrorDateNotInSelectedMonth"];//"Date not in last month";
        }

        return res;
    }



    save = (closeAfterSave) => {
        if (this.common.validate()) {
            if (this.checkErrors()) {

                const tmp = $.extend({}, this.props.entity);
                return HTTPService.post<JsonResultClass>("FlexTime/Save", { model: tmp })
                    .then((result) => {
                        if (result.Code === 0) {
                            this.props.entity.IsNew = false;

                            NotificationHelper.showSuccessMessage(this.translations["WebSMS.FlexTime.Saved"]);
                        } else {
                            NotificationHelper.showErrorMessage(result.Message);
                        }
                        this.common.handlePostSave(result.Code === 0, closeAfterSave);
                        if (result.Code === 0)
                            this.common.sheetWrapper.hide();
                    });
            } else {
                NotificationHelper.showErrorMessage(this.errorText);
            }
        }
    }



    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }
};

interface EditFlexTimeAppProps extends AppBaseProps {
    entity: EditFlexTimeEntity;
}

interface EditFlexTimeEntity extends Entity {
    MonthEnd: string;
    MonthStart: string;
    Datum: string;
    BuchungsDatum: string;
    Minuten: number;
    RessNr: string;
    IsGuid: string;
    Bemerkung: string;
}